module.exports = __webpack_public_path__ + "img/qr-code.279db0e1.jpg";